import { Directive, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
    selector: "[appDnd]"
})
export class DragAndDropDirective {
    @Input() private allowedExtensions: Array<string> = [];
    @Output() private filesChangeEmitter: EventEmitter<File> = new EventEmitter();
    @Output() private filesInvalidEmitter: EventEmitter<File> = new EventEmitter();

    @HostListener("dragover", ["$event"]) onDragOver(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    @HostListener("dragleave", ["$event"]) onDragLeave(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    @HostListener("drop", ["$event"]) onDrop(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            const ext = files[0].name.split(".")[files[0].name.split(".").length - 1];
            if (this.allowedExtensions.lastIndexOf(ext) !== -1) {
                this.filesChangeEmitter.emit(files[0]);
            } else {
                this.filesInvalidEmitter.emit(files[0]);
            }
        }
    }
}
